import React from "react"
import PropTypes from "prop-types"
import Sharetoggle from './sharetoggle';


import ScrollHashAnchor from "./scrollHashAnchor";

class Header extends React.Component {

    constructor(props) {

        super(props);
        // Create the ref
        this.burgerRef = React.createRef();
        this.navbarMenuRef = React.createRef();
        this.showToggleNav = this.showToggleNav.bind(this);
    }

    showToggleNav() {
        if (this.burgerRef.current.classList.contains("is-active")) {
            this.burgerRef.current.classList.remove("is-active");
            this.navbarMenuRef.current.classList.remove("is-active");
        } else {
            this.burgerRef.current.classList.add("is-active");
            this.navbarMenuRef.current.classList.add("is-active");
        }
    }

    render() {
        return (
            <header>
                <nav className="navbar is-dark" role="navigation" aria-label="main navigation">
                    <div className="navbar-brand">
                        <a className="navbar-item" href="/">&nbsp;</a>
                        <a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false"
                           data-target="navbar-khetha" ref={this.burgerRef} onClick={this.showToggleNav}>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                            <span aria-hidden="true"></span>
                        </a>
                    </div>

                    <div id="navbar-khetha" className="navbar-menu" ref={this.navbarMenuRef}>

                        <div className="navbar-start">

                            <ScrollHashAnchor className="navbar-item" to="/#stories-anchor"
                                              scroll={el => el.scrollIntoView({
                                                  behavior: 'smooth',
                                                  block: 'end'
                                              })}>STORIES</ScrollHashAnchor>

                            <ScrollHashAnchor className="navbar-item" to="/about"
                                              scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'end'})}>
                                ABOUT KHETHA</ScrollHashAnchor>

                            <ScrollHashAnchor className="navbar-item" to="/about#partner"
                                              scroll={el => el.scrollIntoView({behavior: 'smooth', block: 'end'})}>
                                PARTNER WITH US</ScrollHashAnchor>

                        </div>
                        <div className="navbar-end">
                            <div className="navbar-item">
                                {/*<a href={`${process.env.SITE_URL}/#stories`} className="navbar-item">*/}
                                <div className="buttons">
                                    <div>
                                        <Sharetoggle/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        )
    }
}

Header.propTypes = {
    siteTitle: PropTypes.string
}

Header.defaultProps = {
    siteTitle: ``
}

export default Header
